export const CHART_TYPES = {
  BAR: 'bar',
  PIE: 'pie',
  LINE: 'line',
};

export const CHARTS = [
  {
    key: 'ageRange',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'generalHealth',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'allergicRhinitis',
    chartType: CHART_TYPES.LINE,
  },
  {
    key: 'asthma',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'allergicConjunctivitis',
    chartType: CHART_TYPES.PIE,
  },
  {
    key: 'allergicUrticara',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'symptomSeveritySnot22',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'physicalActivity',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'fruitVegetableConsumption',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'tobaccoUse',
    chartType: CHART_TYPES.BAR,
  },
];
